import FnAntModal from '../../components/blocks/FnAntModal/index';
import { FnAntModalWidth } from '../../components/blocks/FnAntModal/constants';
import { FULL_DATE_FORMAT } from '../../constants/date';
import React, { FC } from 'react';
import Moment from 'react-moment';
import { TDirectoryName } from '@commonTypes/order';
import { Form, Input } from 'antd';
import { DivWrapper } from './styles';
import { faExclamationTriangle, faCopy } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIconStyled } from '../../components/blocks/FnAntModal/components/Title/styles';
import { FnButtonTypes, FnButtonVariants } from '../../components/elements/FnButton/constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FnButton from '../../components/elements/FnButton';
import { copyTextToClipboard } from '../../util/copy-text-to-clipboard';

const { TextArea } = Input;

type TProps = {
  title: string;
  thumbnailImageUri: string;
  standartId: string;
  createDate: string;
  directoryName: TDirectoryName;
  statusMessage: string;
  onClose: () => void;
};

export const SubmissionDirectoryErrorModal: FC<TProps> = ({
  title,
  thumbnailImageUri,
  standartId,
  createDate,
  directoryName,
  statusMessage,
  onClose
}) => {
  const copyToClipboard = () => {
    copyTextToClipboard(statusMessage, 'Error copied to clipboard');
  };
  
  return (
    <FnAntModal
      className="submission-directory-error-modal"
      titleText={`${directoryName} Submission Log - ${title} (${standartId})`}
      titleImageExistsUri={thumbnailImageUri}
      titleSecondLineLabel="Last Update:"
      titleSecondLineValue={createDate ? <Moment format={FULL_DATE_FORMAT} date={createDate} /> : ''}
      width={FnAntModalWidth.Lg}
      isOpen={true}
      onClose={onClose}
    >
      <DivWrapper>
        <h4 className="mt-30 mb-10">
          <FontAwesomeIconStyled icon={faExclamationTriangle} />
          <span>{directoryName} submission failed</span>
        </h4>

        <Form.Item>
          <TextArea
            value={statusMessage}
            name="statusMessage"
            readOnly={true}
            autoSize={true}
            className="submission-directory-error-modal__textarea"
          />
        </Form.Item>
  
        <FnButton
          className="submission-directory-error-modal__copy-btn"
          variant={FnButtonVariants.Secondary}
          viewType={FnButtonTypes.Text}
          startIcon={<FontAwesomeIcon icon={faCopy}/>}
          text="Copy text"
          onClick={copyToClipboard}
        />
      </DivWrapper>
    </FnAntModal>
  );
};
